module.exports = __webpack_public_path__ + "img/banner2.bb2fbbf1.jpg";